import React from "react";
import { Link } from "react-router-dom";
export default function SmallButton({ label, link, className, onClick }) {
  return (
    <Link to={link} className={`small-btn ${className}`} onClick={onClick}>
      {label}
    </Link>
  );
}
